





import Component from 'vue-class-component'
import DefaultSelect  from '@/components/lib/select/DefaultSelect.vue'
import {SelectModel, StatusType} from '@/services/types'
import {ISelectStatus} from './ISelectStatus'
import * as utils  from '@/services/utils'

@Component({
    components: {
        DefaultSelect
    }
})
export default class SelectStatusFilter extends ISelectStatus {
    private componentClass = 'SelectStatusFilter'

    private  statusSelectOptions: SelectModel [] = [
        {
            value: 'ALL',
            text: 'Все'
        },
        {
            value: 'ACTIVE',
            text: 'Активна'
        },
        {
            value: 'INACTIVE',
            text: 'Деактивирована'
        }
    ]

    get getTitle () {
        return utils.getStatus(this.value as StatusType)
    }

    isActive(value: string) {
        if (value != null) {
            return value == this.value
        }
        else {
            return true
        }        
    }

    onItemSelect(selected: string) {
        if (selected == 'ALL'){
            this.onSelect('null')
        }
        else {
            return this.onSelect(selected)
        }
    }
}
